import React from 'react';
import { bool, object, any } from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { lStorage } from 'modules/utils';
import { redirectUrlBuilder } from './helpers';

const propTypes = {
	component: any,
	isAuthenticated: bool,
	parsedQuery: object,
	client: object,
};

const PrivateRoute = ({
	component: Component,
	isAuthenticated,
	parsedQuery,
	client,
	...rest
}) => (
	<Route
		{...rest}
		render={props => {
			const { user } = lStorage.get({ key: 'current-user' });
			// eslint-disable-next-line react/prop-types
			const { location } = props;

			if (!isAuthenticated) {
				return (
					<Redirect
						to={{
							pathname: '/login',
							state: { from: location },
						}}
					/>
				);
			}

			if (user.restrictedUser && user.accessWhiteList.length) {
				const { redirecting, link } = redirectUrlBuilder(user, location);
				if (redirecting) {
					return <Redirect to={link} />;
				}
			}

			return (
				<Component
					{...props}
					parsedQuery={parsedQuery}
					logout={rest.logout}
					client={client}
				/>
			);
		}}
	/>
);

PrivateRoute.propTypes = propTypes;

export default PrivateRoute;
